// 选择商品相关接口

import { postBlobFile, imagePost, get, deleteApi, postJson } from "../axios";

// 选择商品sku列表
export const getSkuList = (p) => postJson(`/common/sku/page`, p);

// 选择商品spu列表
export const getItemList = (p) => postJson(`/common/item/page`, p);

// 获取商品品牌
export const getBrandList = (p) => get(`/common/item/getBrands`, p);

// 查询常用列表
export const getCollectList = (p) => get(`/analysisConfig/tree`, p);

// 查询常用列表
export const getIdsByFile = (p) =>
  imagePost(`/common/getItemOrSkuListByFile`, p);
